import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/core/service/common-service/common.service'
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})

export class ProfileComponent implements OnInit {
  passwordForm: FormGroup;
  phoneForm: FormGroup;
  submittedPhone = false;
  submitted: boolean;
  spinner: boolean;
  wrongPass: boolean;
  diffPassword: boolean;
  userId: string;
  userInfo: any;
  passwordPattern: any;
  samePassword: boolean;
  countryCode: string;
  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {
    this.userId = localStorage.getItem('userId');
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.countryCode = localStorage.getItem('countryCode');
    this.userInfo = userInfo[0];
    this.buildForm();
  }

  /**
  * Name: buildForm
  * purpose: To build Form
  */
  buildForm(): void {
    this.passwordPattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+-=]).{8,255}$';
    this.passwordForm = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });
    this.phoneForm = this.fb.group({
      phoneNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]]
    });
  }

  /**
  * Name: hasError
  * purpose: To check if form has any error
  * @param {any} control - form control
  * @return {boolean} flag to determine if form is valid.
  */
  hasError(control: any): boolean {
    return (
      control &&
      (this.submitted || control.touched || control.dirty) && !control.valid);
  }

  /**
  * Name: checkPassword
  * purpose: To check user enter valid pass
  */
  checkPassword(): void {
    let f = this.passwordForm;
    if (f.value.newPassword != f.value.confirmPassword) {
      this.diffPassword = true;
      return;
    }
    if(this.passwordForm.controls.newPassword.value==this.passwordForm.controls.currentPassword.value){
      this.samePassword=true
      return;
    }else if(this.passwordForm.controls.newPassword.value!=this.passwordForm.controls.currentPassword.value){
      this.samePassword=false
    }
    this.submitted = true;
    if (f.valid) {
      this.commonService.signin(this.userId, f.value.currentPassword).subscribe(
        res => {
          if (res['responseCode'] == 0) {
            this.wrongPass = false;
            this.changePassword(f.value.currentPassword, f.value.newPassword);
          } else {
            this.wrongPass = true;
          }
        }, err => {
          this.toastr.error("Something went wrong, Please try again.", "Error");
        });
    }
  }

  /**
  * Name: changePassword
  * purpose: To changes user password
  * @param {string} currentPassword - The currentPassword
  * @param {string} newPassword - The newPassword to update
  */
  changePassword(currentPassword: string, newPassword: string): void {
    this.spinner = true;
    this.commonService.updatePassword(this.userId, currentPassword, newPassword).subscribe(
      res => {
        if (res['responseCode'] == 0) {
          this.spinner = false;
          this.toastr.success('Password updated successfully', "Success");
          this.logout();
        }
        else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
  * Name: logout
  * purpose: To Sign out user
  */
  logout(): void {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  onSubmit() {
    this.spinner = true;
    this.submittedPhone = true;
    if (this.phoneForm.valid) {
      this.commonService.changePhoneNumberAfterLogin(this.userId, this.phoneForm.value.phoneNumber).subscribe(res => {
        if (res['responseCode'] === 0) {
          this.spinner = false;
          this.toastr.success('Phone number updated successfully');
          this.logout();
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], 'Error');
        }
      }, error => {
        this.spinner = false;
        this.toastr.error(error, 'Error');
      });
    } else {
      this.toastr.error('Please enter valid phone number', 'Error');
      this.submittedPhone = false;
      this.spinner = false;
    }
  }
}
